import { Link } from 'react-router-dom'
import { PageHeaderProps } from './props.js'
import { ArrowLeftIcon } from './icons.js'

export function PageHeader({
  title,
  subtitle,
  actions,
  back,
  className = '',
}: PageHeaderProps) {
  return (
    <div className={`mb-6 ${className}`}>
      {back && (
        <Link
          to={back.to}
          onClick={back.onClick}
          className="inline-flex items-center gap-1 text-on-surface-variant text-body-sm hover:text-on-surface mb-4"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          {back.label}
        </Link>
      )}
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
        <div className="flex-1 min-w-[16rem]">
          <h1 className="text-headline-lg text-on-surface">{title}</h1>
          {subtitle && (
            <p className="text-body-sm text-on-surface-variant mt-1">
              {subtitle}
            </p>
          )}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2 max-w-full sm:justify-end">{actions}</div>}
      </div>
    </div>
  )
}
